import { ContentState, EditorState } from "draft-js";

export const setEditorStateAfterInsert = (state: EditorState, content: ContentState, initContent: ContentState) => {
    if (content !== initContent) {
        // don't make any changes to selection
        content = content.merge({
            selectionBefore: initContent.getSelectionBefore(),
            selectionAfter: initContent.getSelectionAfter(),
        }) as ContentState;

        // to get working ctrl+z properly when mention entities were added to state.
        state = EditorState.set(state, { allowUndo: false });
        state = EditorState.push(state, content, "apply-entity");
        state = EditorState.set(state, { allowUndo: true });
    }
    return state;
};
